var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShellFile = function SvgShellFile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3C40C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.355 0h-9.86c-.048 0-.094.01-.142.014v4.28c0 1.057-.859 1.916-1.916 1.916H.157c-.004.048-.014.093-.014.141v14.73A.92.92 0 0 0 1.06 22h15.294a.92.92 0 0 0 .919-.919V.918A.92.92 0 0 0 16.355 0zm-8.82 14.354l-3.444 3.444-.707-.707L6.474 14l-3.09-3.09.707-.707 3.444 3.443a.5.5 0 0 1 0 .708zm6.144 3.59H8.734v-1h4.945v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59 4.373V.038L.183 5.413h4.36c.577 0 1.047-.467 1.047-1.04z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShellFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shellFile.0ce1687f.svg";
export { ForwardRef as ReactComponent };